import React,{useState,useEffect} from 'react'
import BlogContent from '../component/BlogContent/BlogContent'
import Footer from "../component/Footer/Footer"
import axios from 'axios'
import { Spinner } from 'react-bootstrap'
import { useParams } from "react-router";
import { Helmet } from "react-helmet";
import PlainHero from '../component/PlainHero/PlainHero'

function BlogInner() {
  const [blogsData, setBlogsData] = useState();
  const [recentBlogs, setRecentBlogs] = useState([]);

  const [loading, setLoading] = useState(false);

  const id  = useParams().id;

  let blogAPICalledId = false;
  let allBlogsCalled = false;

  const getAllBlogs = async () => {
    if (allBlogsCalled) return;
    allBlogsCalled = true;

    setLoading(true);
    
    axios
      .get(`/blogs`, {})
      .then((res) => {
        if (res.data.status === "success") {
          let Updated_recent_blogs = [];
          
          let blog = res.data.data.find((item) => item.slug_url == id);
          setBlogsData(blog);

          res.data.data.forEach((item) => {
            Updated_recent_blogs.push({
              id: item.blog_id,
              slug_url: item.slug_url,
              logo: item.blog_image,
              blog_description: item.title,
              date: item.published_date,
            });
          });
          setRecentBlogs(Updated_recent_blogs.slice(0, 2));
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err");
        setBlogsData(null)
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllBlogs();
  }, [id]);



  return (
    <>
    {loading  ? (
          <div
            style={{ width: "100%", height: "100vh" }}
            className="d-flex justify-content-center align-items-center"
          >
            <Spinner
              style={{ color: "black", width: "120px", height: "120px" }}
            />
          </div>
        ) :
        (
          <>
            {blogsData ?

              <PlainHero  
                Heading={blogsData.title}
                fontDark={true}
                date={blogsData.published_date}
              />
              :
              <PlainHero/>
            }
            
          
            {blogsData && 
              <>
                <Helmet>
                  {blogsData.metaTitle && <title>{blogsData.metaTitle}</title>}
                  {blogsData.metaDescription && <meta name='description' content={blogsData.metaDescription} />}
                  {blogsData.slug_url && <link rel="canonical" href={`https://www.haltonsurfacesystems.com/artical/${blogsData.slug_url}`}></link>}
                </Helmet>
                

                {blogsData?.blog_image && <div className='container d-flex align-items-center justify-content-center'><img src={blogsData?.blog_image} className='img-fluid ' alt='icon'/></div>}

                <BlogContent
                  blogsData={blogsData.blogs_content}
                  text={blogsData.brief_paragraph}
                  recentBlogs={recentBlogs}
                />

                {/* <BlogInnerLatest
                  latestNewsData={recentBlogs}
                /> */}
            </>}
            
            </>
          )}

        <Footer/>
    </>
  )
}

export default BlogInner